import React, { useMemo } from 'react';
import { extend } from '@thd-nucleus/data-sources';
import {
  PodSection,
  ProductPod,
  ProductImage,
  ProductRating,
  PodFooter,
  PodSpacer,
  ProductATC,
  ProductSponsored
} from '@thd-olt-component-react/product-pod';
import proptypes from 'prop-types';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { Price } from '@thd-olt-component-react/price';

const { bool: boolType, string: stringType, number: numType } = proptypes;

export const VerticalRecsProductPodV7 = (props) => {
  const {
    itemId,
    storeId,
    position,
    preferredPriceFlag,
    parent,
    scheme,
    anchorProduct,
    strategy,
    brandTitleMaxLine,
    hideRating,
    hideBadge,
    hideATC,
    noATCFulfillment,
    isMobile,
    onlyReviewCount,
    isMerchRecRequired
  } = props;

  const anchorId = (anchorProduct.length > 2) ? anchorProduct : 'n/a';

  const merchRec = useMemo(() => {
    return isMerchRecRequired ? `MERCH=REC-_-${scheme}-_-${anchorId}-_-${position}-_-n/a-_-n/a-_-n/a-_-n/a-_-n/a` : null;
  }, [anchorId, position, isMerchRecRequired, scheme]);

  return (
    <ProductPod
      itemId={itemId}
      storeId={storeId}
      analyticsData={{
        parent, position, scheme, anchorProduct, strategy
      }}
      padding="sui-p-0"
      gap="sui-gap-0"
      render={(pod) => (
        <>
          <PodSection noPadding>
            <div className="sui-grid sui-grid-cols-3 sui-gap-2">
              <div className="sui-grid-cols-1">
                <ProductImage
                  itemId={pod.itemId}
                  fetchPriority="high"
                  merchQueryParam={merchRec}
                />
              </div>
              <div className="sui-col-span-2">
                <PodSection noPadding columnAlign>
                  <ProductHeader
                    brand="inline"
                    brandFontSize="sm"
                    itemId={pod.itemId}
                    brandTitleMaxLine={isMobile ? 3 : brandTitleMaxLine}
                    disableShopThisCollection
                    merchQueryParam={merchRec}
                    productNameLineHeight="tight"
                  />
                  {!hideRating && (
                    <ProductRating
                      itemId={pod.itemId}
                      merchQueryParam={merchRec}
                      onlyReviewCount={onlyReviewCount}
                    />
                  )}
                  <Price
                    itemId={pod.itemId}
                    large={false}
                    storeId={storeId}
                    displayEachUom={false}
                    hideSavingsText={!preferredPriceFlag}
                    showPreferredPricingBadge
                  />
                  {!hideATC && (
                    <PodFooter noPadding>
                      <PodSpacer minHeight="40px">
                        <ProductATC
                          itemId={pod.itemId}
                          checkGeneric
                          outline
                          noATCFulfillment={noATCFulfillment}
                        />
                      </PodSpacer>
                    </PodFooter>
                  )}
                </PodSection>
              </div>
            </div>
          </PodSection>
          <div className="sui-flex sui-justify-start sui-recs-pipsem-sponsoredbadge">
            <ProductSponsored itemId={pod.itemId} position={position} noBackground noPadding />
          </div>
        </>
      )}
    />
  );
};

VerticalRecsProductPodV7.dataModel = extend(
  ProductPod,
  ProductImage,
  ProductRating,
  Price,
  ProductHeader,
  ProductSponsored
);

VerticalRecsProductPodV7.propTypes = {
  itemId: stringType.isRequired,
  storeId: stringType,
  position: numType,
  parent: stringType,
  preferredPriceFlag: boolType,
  scheme: stringType.isRequired,
  anchorProduct: stringType,
  strategy: stringType,
  brandTitleMaxLine: numType,
  hideRating: boolType,
  hideBadge: boolType,
  hideATC: boolType,
  noATCFulfillment: boolType,
  isMobile: boolType,
  onlyReviewCount: boolType,
  isMerchRecRequired: boolType
};

VerticalRecsProductPodV7.defaultProps = {
  storeId: '',
  position: null,
  brandTitleMaxLine: 2,
  preferredPriceFlag: false,
  parent: '',
  strategy: 'project-based',
  anchorProduct: '',
  hideRating: false,
  hideBadge: false,
  hideATC: false,
  noATCFulfillment: true,
  isMobile: false,
  onlyReviewCount: true,
  isMerchRecRequired: true
};

VerticalRecsProductPodV7.displayName = 'VerticalRecsProductPodV7';